import { gql } from '@apollo/client';

export const GALLERY_FRAGMENT = gql`
  fragment GalleryFragment on Gallery {
    _id
    photoUrl
    createdAt
  }
`;
